import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { SafeHtml } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs/Rx';

import { TestTakerActions, AppUiActions } from '../../../../../../store/actions';
import * as fromRoot from '../../../../../../store/reducers';
import { HtmlService } from './../../../../../../services/html.service';
import { TestNavigationService } from '../../../../../../services/test-navigation.service';
import { TestTakerService } from '../../../../../../services/test-taker.service';
import { TestContentService } from '../../../../../../services/test-content.service';
import { MyModal } from './../../../../../common/my-modal/my-modal.component';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'ipp-landing-page',
    template: require('./ipp-landing-page.component.html')
})

export class IppLandingPageComponent {
    @Input() htmlResourceId: number;
    @Input() pictureResourceId: number;
    imageData: string;
    productName: string;
    private preTestDescription: SafeHtml;
    private isModalVisible: boolean;
    private tests = [];
    private imageReady = false;

    associatedAssessmentTests$: Observable<number[]>;
    private associatedAssessmentTestsSubscription: Subscription;
    associatedAssessmentTestIds: number[];

    constructor(
        private store: Store<fromRoot.State>,
        private htmlService: HtmlService,
        private testNavigationService: TestNavigationService,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private myModal: MyModal
    ) {
        this.associatedAssessmentTests$ = store.select(fromRoot.getAssociatedAssessmentTests);

        this.associatedAssessmentTestsSubscription = this.associatedAssessmentTests$.subscribe(associatedAssessmentTestIds => {
            this.associatedAssessmentTestIds = associatedAssessmentTestIds;
        });

        this.testNavigationService.setCanGoNext(false);
    }

    ngOnInit() {
        if (this.associatedAssessmentTestIds.length != 0) {
            this.testContentService.getProductInfo(this.associatedAssessmentTestIds[0].toString()).subscribe(dto => {
                if (dto != null) {
                    this.productName = dto.Name;
                }
            });
        }
        if (_paragonConfig.mode === "ipp") {
           this.testTakerService.getIppTestTakerInfo(this.associatedAssessmentTestIds[0]).subscribe(
            ippTestTakerInfo => {
                this.store.dispatch(new TestTakerActions.SetTestTakerInfo(ippTestTakerInfo));
                this.imageData = this.htmlService.getResourceUrl(this.pictureResourceId);
                this.getPreTestDescription();
           });
        } else {
            this.imageData = this.htmlService.getResourceUrl(this.pictureResourceId);
            this.getPreTestDescription();
        }

        this.changeLandingPageCss(true);
        this.getAvailableIppAssessmentTests();
        this.isModalVisible = false;
    }

    changeLandingPageCss(shouldAdd: boolean) {
        if (shouldAdd) {
            $("top-nav").addClass("landing-page");
            $("div.view-container").addClass("landing-page");
        } else {
            $("top-nav").removeClass("landing-page");
            $("div.view-container").removeClass("landing-page");
        }
    }

    // if there is more than 1 test form associated with product, show list of test forms
    // otherwise, just start up the session
    chooseIppTest() {
        if (this.associatedAssessmentTestIds.length > 1 && _paragonConfig.mode == "ipp") {
            this.isModalVisible = true;
        } else {
            this.changeLandingPageCss(false);
            this.testNavigationService.setCanGoNext(true);
            this.testNavigationService.goNext(true);
        }
    }

    // start up the session using the selected test form
    startIppTest(ippAssessmentTestId : number) {
        this.changeLandingPageCss(false);
        this.store.dispatch(new TestTakerActions.LoadIppAssessmentTest(ippAssessmentTestId));
        this.testTakerService.getIppTestTakerInfo(ippAssessmentTestId).subscribe(
            ippTestTakerInfo => {
                this.store.dispatch(new TestTakerActions.SetTestTakerInfo(ippTestTakerInfo));
        });
        this.loadTestletsAndNavigateToFirstTestlet(ippAssessmentTestId);
    }

    private loadTestletsAndNavigateToFirstTestlet(assessmentTestId) {
        this.testContentService.getIppAssessmentTest(assessmentTestId).subscribe (
            ippAssessmentTestDto => {
                this.testNavigationService.getTestlets(ippAssessmentTestDto.IppAssessmentTest).forEach(t => {
                    this.store.dispatch(new TestTakerActions.LoadTestlet(t.testletId, ippAssessmentTestDto.IppAssessmentTest));
                });
                var firstTestlet = this.testNavigationService.getTestlets(ippAssessmentTestDto.IppAssessmentTest)[1]
                var landingPageNavigation = firstTestlet.testNavigation;
                this.store.dispatch(new TestTakerActions.SetTestNavigation(landingPageNavigation));
            },
            error => {
                this.myModal.showRegularDlg("Error", error);
            }
        );
    }

    getAvailableIppAssessmentTests() {
        this.associatedAssessmentTestIds.forEach(id => {
            this.testContentService.getIppAssessmentTest(id).subscribe(
                ippAssessmentTest => {
                    this.tests.push(ippAssessmentTest);
                }
            )
        });
    }

    getPreTestDescription() {
        this.htmlService.getHtmlResource(this.htmlResourceId).subscribe(html => {
            var regex = /<div id="popup" title="([\s\S]*?)">([\s\S]*?)<\/div>/igm;
            var matchedArray: RegExpExecArray;
            if ((matchedArray = regex.exec(html)) != null) {
                if (this.imageReady) {
                    this.myModal.showRegularDlg(matchedArray[1], matchedArray[2]);
                } else {
                    // Delay dialog
                    let cb = this.onImageReady;
                    this.onImageReady = () => {
                        this.myModal.showRegularDlg(matchedArray[1], matchedArray[2]);
                        cb.apply(this);
                    }
                }
            }
            html = html.replace(regex, ``);
            html = html.replace(/<p id="warning" title="([\s\S]*?)">([\s\S]*?)<\/p>/igm, `<p id="warning" class="alert alert-block alert-info""><span class="badge badge-important">$1</span> $2<\/p>`);

            this.preTestDescription = this.htmlService.getSafeHtml(html);
        });
    }

    onImageReady() {
        this.imageReady = true;
    }

    closeModal() {
        this.isModalVisible = false;
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-landing-page/ipp-landing-page.component.ts